import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // Afficher un indicateur de chargement pendant l'initialisation
  if (loading) {
    return <div>Chargement...</div>;
  }

  // Si l'utilisateur n'est pas connecté, rediriger vers la page de connexion
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Sinon, afficher le contenu protégé
  return children;
};

export default PrivateRoute;
